import React, {Component} from "react";
import Checkbox from "./Checkbox";
import {durationToString} from "../../../../services/DurationUtil";
import SAInfoBubble from "../../../../components/common/confirmation/SAInfoBubble";
import PriceTag from '../../../../components/common/pricetag/PriceTag';

class CheckboxServiceItem extends Component {

  constructor(props){
    super(props)
    this.state = {
      checked:props.checked,
    }
  }

  onChange = (value, item) => {
    this.props.onChange(value, item);
    this.setState({checked:value});

  }
  render(){
    const {item, ...rest} = this.props;

    return <React.Fragment>
      <Checkbox
        {...rest}
        id={item.name}
        onChange={value=>this.onChange(value, item)}
        checked={this.state.checked}>
        <span>{item.title}</span>
        <span style={{float:'right'}}>
          <PriceTag price={item.price}/>&nbsp;{item.duration ? `${durationToString(item.duration)}` : ''}{' '}
          {item.moreInfo && <SAInfoBubble content={item.moreInfo}/>}
        </span>
        {item.description && <div style={{paddingLeft: '3rem', 'font-weight': 'normal'}}>{item.description}</div>}
      </Checkbox>
    </React.Fragment>

  }
}


export default CheckboxServiceItem;



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/services/CheckboxServiceItem.js